import { combineReducers } from "redux"
import EmployeeHoverCardReducer from "./EmployeeHoverCardReducer"
import { geoInfoReducer } from "./geoInfoReducer"

const rootReducer = combineReducers({
  geoInfo: geoInfoReducer,
  employeeHover: EmployeeHoverCardReducer
})

export default rootReducer